import { render, staticRenderFns } from "./EditPages.vue?vue&type=template&id=7b15e910"
import script from "./EditPages.vue?vue&type=script&lang=js"
export * from "./EditPages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports